export default __webpack_public_path__ + "0e7683412afef63105ae45939015ee11.png";